import { getAppSettings } from '../../config';

const appSettings = getAppSettings();
const APIBaseUrl = appSettings.apiGateway.API_URL;
const imageURL = window.location.origin;

export const ApiUrlConstants = {
    AccessControl: {
        DeviceUUIDEndPoint: APIBaseUrl + "/Device/DeviceUUID",
        VippsEndPoint: APIBaseUrl + "/VippsLogin/StartAuthentication",
        VippsAuthEndPoint: APIBaseUrl + "/VippsLogin/AfterAuthentication",
        SmsEndPoint: APIBaseUrl + "/Sms/Send",
        SmsVerifyOTPEndPoint: APIBaseUrl + "/Sms/VerifyOTP",

    },
    PreLoadImage: {
        ImageDirEndPoint: imageURL + '/images/'
    }
}